import { MyLessons, NewLesson } from "@/types/MyLessons";
import { MutationTree } from "vuex";
import { State, getDefaultState } from "./orai";
import { LearnerRecordings } from "@/types/LearnerRecordings";
import {
  LearnerTeam,
  Team,
  TeamEngagement,
  TeamLeaderboard,
  TeamCompletion,
  TeamPerformance,
  UserStat,
  User,
  TeamLesson,
  UserMeta,
  TeamActivity,
  UserPlan,
  Review,
  Rubric,
  RubricSessionAnswers,
  SessionFeedback,
  LearnerReviews,
  RubricAnswersByUser,
  RubricAnswers,
  TeamReviewSettings,
  AvailablePlan,
  License,
} from "@/types";

export const mutations: MutationTree<State> = {
  learnerLessons(state: State, myLessons: NewLesson[]) {
    state.myLessons = myLessons;
  },
  learnerRecordings(state: State, myRecordings: LearnerRecordings) {
    state.learnerRecordings = myRecordings;
  },
  learnerReviews(state: State, myReviews: LearnerReviews[]) {
    state.learnerReviews = myReviews;
  },
  setLearnerTeams(state: State, learnerTeams: LearnerTeam[]) {
    state.learnerTeams = learnerTeams;
  },
  setJWT(state: State, jwt: string) {
    state.JWT = jwt;
  },
  setUID(state: State, UID: string) {
    state.UID = UID;
  },
  setInitAssessment(state: State, doneInitAssessment: boolean) {
    state.doneInitAssessment = doneInitAssessment;
  },
  setTeams(state: State, teams: Team[]) {
    state.teams = teams;
  },
  setTeam(state: State, team: Team) {
    state.currentTeam = team;
  },
  setLearnerTeam(state: State, learnerTeam: LearnerTeam) {
    state.currentLearnerTeam = learnerTeam;
  },
  setDisplayError(state: State, error: any) {
    state.displayError = error;
  },
  setTeamEngagement(state: State, teamEngagement: TeamEngagement) {
    state.teamEngagement = teamEngagement;
  },
  setTeamCompletion(state: State, teamCompletion: TeamCompletion) {
    state.teamCompletion = teamCompletion;
  },
  setTeamLeaderboard(state: State, teamLeaderboard: TeamLeaderboard) {
    state.teamLeaderboard = teamLeaderboard;
  },
  setTeamPerformanceOverall(state: State, teamPerformance: TeamPerformance) {
    state.teamPerformanceOverall = teamPerformance;
  },
  setTeamPerformancePace(state: State, teamPerformance: TeamPerformance) {
    state.teamPerformancePace = teamPerformance;
  },
  setTeamPerformanceConciseness(
    state: State,
    teamPerformance: TeamPerformance
  ) {
    state.teamPerformanceConciseness = teamPerformance;
  },
  setTeamPerformanceFillers(state: State, teamPerformance: TeamPerformance) {
    state.teamPerformanceFillers = teamPerformance;
  },
  setCurrentTeamStats(state: State, stats: UserStat[]) {
    state.currentTeamStats = stats;
  },
  setCurrentTeamActivity(state: State, activity: TeamActivity[]) {
    state.currentTeamActivity = activity;
  },
  setCurrentTeamUsers(state: State, users: User[]) {
    state.currentTeamUsers = users;
  },
  setTeamLessons(state: State, tl: TeamLesson[]) {
    state.teamLessons = tl;
  },
  setUserMeta(state: State, um: UserMeta) {
    state.userMeta = um;
  },
  setLicenseList(state: State, licenseList: License[]) {
    state.userLicenseList = licenseList;
  },
  setUserPlan(state: State, plan: UserPlan) {
    state.userPlan = plan;
  },
  setUserPlanLoading(state: State, loading: boolean) {
    state.userPlanLoading = loading;
  },
  setAvailablePlansLoading(state: State, loading: boolean) {
    state.availablePlansLoading = loading;
  },
  setAvailablePlans(state: State, plans: AvailablePlan[]) {
    state.availablePlans = plans;
  },
  setRecordedVideoURL(state: State, url: string | null) {
    state.recordedVideoURL = url;
  },
  setSessionReviewRequired(state: State, review: Review[]) {
    state.sessionReviewRequired = review;
  },
  setSessionAlreadyReviewed(state: State, review: Review[]) {
    state.sessionAlreadyReviewed = review;
  },
  setTranscriptStartIndex(state: State, startIndex: number) {
    state.transcriptStartIndex = startIndex;
  },
  setTranscriptEndIndex(state: State, endIndex: number) {
    state.transcriptEndIndex = endIndex;
  },
  setReviewCommentSelectedIndex(state: State, index: number) {
    state.reviewCommentSelectedIndex = index;
  },
  setReviewCommentPlay(state: State, index: number) {
    state.reviewCommentPlay = index;
  },
  setNewReviewCommentVisible(state: State, isVisible: boolean) {
    state.newReviewCommentVisible = isVisible;
  },
  setRubricData(state: State, rubric: Rubric) {
    state.rubricData = rubric;
  },
  setRubricSessionAnswers(
    state: State,
    rubricSessionAnswers: RubricSessionAnswers[]
  ) {
    state.rubricSessionAnswers = rubricSessionAnswers;
  },
  setRubricSessionAnswersByUser(
    state: State,
    rubricAnswersByUser: RubricAnswersByUser[]
  ) {
    state.rubricSessionAnswersByUser = rubricAnswersByUser;
  },
  setRubricSessionAverageAnswers(state: State, rubricAnswers: RubricAnswers[]) {
    state.rubricSessionAverageAnswers = rubricAnswers;
  },
  setTeamReviewSettings(state: State, teamReviewSettings: TeamReviewSettings) {
    state.teamReviewSettings = teamReviewSettings;
  },
  setReviewFeedbackComments(state: State, sessionFeedback: SessionFeedback[]) {
    state.sessionFeedback = sessionFeedback;
  },
  resetState(state: State) {
    let def: any = getDefaultState() as Object;
    let temp: any = state as Object;
    for (const key in def) {
      if (def.hasOwnProperty(key)) {
        // const element = object[key];
        temp[key] = def[key];
      }
    }
  },
};
